#import "./quote-money-fragment.graphql"

fragment ProductLineItemFragment on QuoteProductLineItemsConnection {
    totalCount
    edges {
        node {
            id
            name
            product {
                id
            }
            price {
                ...QuoteMoneyFragment
            }
            description
            sku
            quantity
            formattedQuantity
            term
            discountUnit
            discountNumber
            formattedDiscount
            total {
                ...QuoteMoneyFragment
            }
        }
    }
}
